import { tanksAccionesRoles } from '../../acciones-roles/departamentos/tanks-acciones-roles';
import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import {
  PreConfigButton2,
  PreConfigButton3,
} from '../../nav-list/recursive-sidebar/configuration/preconfig';

export const TanksRoutes: SideBarButton = {
  data: {
    name: 'Tanques',
    appendUrl: './tank',
    roles: tanksAccionesRoles.sideNavActions.root, // ← Agregado
  },
  options: PreConfigButton2,
  butons: [
    {
      data: {
        name: 'Escáner',
        url: '/box',
        otherUrls: ['/box/:teamId', '/box/:teamId/:workOrder'],
        roles: tanksAccionesRoles.sharedActions.scanPackingBox,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Packing Box',
        url: '/packing-box',
        roles: tanksAccionesRoles.sharedActions.packingBox,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Crear pallet',
        url: '/pallet',
        otherUrls: ['/pallet/:teamId', '/pallet/:teamId/:palletId'],
        roles: tanksAccionesRoles.sharedActions.palletRegistration,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Reporte pallets',
        url: '/data',
        roles: tanksAccionesRoles.routerActions.viewData,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Validacion',
        url: '/validation',
        roles: tanksAccionesRoles.sharedActions.validatePallets,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Ensamble',
        url: '/part-scrap',
        otherUrls: ['/part-scrap/:teamId'],
        roles: tanksAccionesRoles.sharedActions.scanPartScrap,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Inspección final',
        url: '/part-scrap-final',
        otherUrls: ['/part-scrap-final/:teamId'],
        roles: tanksAccionesRoles.sharedActions.scanPartScrap,
      },
      options: PreConfigButton3,
    },
    {
      data: {
        name: 'Reporte Power BI',
        overWriteUrl: './reportsPBI/tanks',
        roles: tanksAccionesRoles.sideNavActions.reportsPbiTanks,
      },
      options: PreConfigButton3,
    },
  ],
};
